<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9Ll73G/tc-custom/9781453233337.jpg?1733083254395" alt="This image is the cover for the book Fifth Key, The Kent Murdock Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fifth Key, The Kent Murdock Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>An old friend of Kent Murdock’s is murdered, leaving him to take the fall</b>It’s been two years since Kent Murdock saw Sheila, and it only takes a few minutes to remember her flaws. While the Boston newspaper photographer was away fighting in the European war, Sheila’s cold ambition took her out of the newsroom and into the studio, to write a radio show that’s about to land her in the big time. The wallflower he once knew is now the center of attention—not all of it pleasant. One night Murdock follows her home for a drink. It proves to be a deadly mistake. A drugged bottle of Scotch knocks Murdock out, and when he comes to, he finds Sheila dead, strangled on the floor. The Scotch—the only evidence of his innocence—is gone, and Murdock is the natural suspect for the beautiful young writer’s death. Which means he’s going to have to find the killer himself.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Harmon Coxe
      </h2>
      
      <p class="authorDescription body article">George Harmon Coxe (1901&ndash;1984) was an early star of hard-boiled crime fiction, best known for characters he created in the seminal pulp magazine <i>Black Mask</i>. Born in upstate New York, he attended Purdue and Cornell Universities before moving to the West Coast to work in newspapers. In 1922 he began publishing short stories in pulp magazines across various genres, including romance and sports. He would find his greatest success, however, writing crime fiction.&#160;In 1934 Coxe, relying on his background in journalism, created his most enduring character: Jack &ldquo;Flashgun&rdquo; Casey, a crime photographer. First appearing in &ldquo;Return Engagement,&rdquo; a <i>Black Mask </i>short, Casey found success on every platform, including radio, television, and film. Coxe&rsquo;s other well-known characters include Kent Murdock, another photographer, and Jack Fenner, a PI. Always more interested in character development than a clever plot twist, Coxe was at home in novel-writing, producing sixty-three books in his lifetime. Made a Grand Master of the Mystery Writers of America in 1964, Coxe died in 1984.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mysterious Press/Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d7d83a6